import CreateBanner from "../../components/Banner/Actions/CreateBanner";

export default function CreateBannerScreen(){
return <CreateBanner />
}